import React, { createContext, useEffect, useReducer, useState } from "react"
import { STORAGE_KEY } from "@bbxbratz/game/constants/constants"

const initialState = {
	username: "",
	doll: null,
	top: null,
	bottoms: null,
	onePiece: null,
	towel: null,
	pouch: null,
	polaroid: "dlPolaroid1",
}

const reducer = (state, action) => {
	switch (action.type) {
		case "SET_FIELD":
			return {
				...state,
				[action.key]: action.value,
			}
		case "SET_MULTIPLE": {
			return {
				...state,
				...action.payload,
			}
		}
		case "RESET_DEFAULT":
			if (typeof window !== "undefined") localStorage.removeItem(STORAGE_KEY)
			return initialState
		default:
			return state
	}
}

const BBxBratzContext = createContext({
	state: initialState,
	dispatch: () => {},
	gameScreen: "",
	setGameScreen: () => {},
})

export const BBxBratzProvider = ({ children }) => {

	const [pixiAppContext, setPixiAppContext] = useState(null)
	const [gameStart, setGameStart] = useState(false)
	const [gameScreen, setGameScreen] = useState("")
	const [isResetDefaultDress, setIsResetDefaultDress] = useState(false)
	const [openSizeGuideModal, setOpenSizeGuideModal] = useState(false)
	const [shareThisGameModal, setShareThisGameModal] = useState(false)
	const [openDownloadSuccessModal, setOpenDownloadSuccessModal] = useState(false)
	const [finaleShareBtnClicked, setFinaleShareBtnClicked] = useState(false)
	const [finaleDownloadBtnClicked, setFinaleDownloadBtnClicked] = useState(false)
	
    const [topVariant, setTopVariant] = useState(null)
	const [bottomVariant, setBottomVariant] = useState(null)
    const [onePieceVariant, setOnePieceVariant] = useState(null)

    const [pouchVariant, setPouchVariant] = useState(null)
    const [towelVariant, setTowelVariant] = useState(null)
    

	const initializer = () => {
		if (typeof window !== "undefined") {
			try {
				const stored = localStorage.getItem(STORAGE_KEY)
				if (!stored) return initialState

				const parsed = JSON.parse(stored)
				return parsed.state ?? initialState
			} catch {
				return initialState
			}
		}
		return initialState
	}
    
   

	const setOnePiece = (id) => {
		dispatch({ type: "SET_MULTIPLE", payload: { top: null, bottoms: null, onePiece: id } })
	}

	const resetDefaultDress = () => {
		// console.info("default:",isResetDefaultDress)
		setIsResetDefaultDress(true)
	}

	const resetToDefault = () => {
		setGameScreen("")
		dispatch({ type: "RESET_DEFAULT"})
        setTopVariant(null)
        setBottomVariant(null)
        setOnePieceVariant(null)
        setPouchVariant(null)
        setTowelVariant(null)
	}

	const [state, dispatch] = useReducer(reducer, initialState, initializer)

	useEffect(() => {
		localStorage.setItem(STORAGE_KEY, JSON.stringify({ state }))
	}, [state])

	return (
		<BBxBratzContext.Provider
			value={{
				state,
				dispatch,
				gameStart,
				setGameStart,
				gameScreen,
				setGameScreen,
				resetToDefault,
				isResetDefaultDress,
				setIsResetDefaultDress,
				resetDefaultDress,
				setOnePiece,
				pixiAppContext,
				setPixiAppContext,
				openSizeGuideModal,
				setOpenSizeGuideModal,
				openDownloadSuccessModal,
				setOpenDownloadSuccessModal,
				shareThisGameModal,
				setShareThisGameModal,
                topVariant,
                setTopVariant,
                bottomVariant,
                setBottomVariant,
                onePieceVariant,
                setOnePieceVariant,
                pouchVariant,
                setPouchVariant,
                towelVariant,
                setTowelVariant,
				finaleShareBtnClicked,
				setFinaleShareBtnClicked,
				finaleDownloadBtnClicked,
				setFinaleDownloadBtnClicked,
			}}
		>
         
			{children}
		</BBxBratzContext.Provider>
	)
}

export default BBxBratzContext
